import { ChangeDetectorRef, Directive, ElementRef, Input, NgModule, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Constants } from '@app/common/constants';
import { ImageService } from '@app/services/image.service';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[appImgSrcProxy]'
})
export class ImgSrcProxyDirective implements OnInit, OnDestroy {
  subscription: Subscription;
  @Input('appImgSrcProxy') originalUrl: string;

  constructor(private el: ElementRef,
              private imageService: ImageService,
              private renderer2: Renderer2,
              private cdRef: ChangeDetectorRef) {
    this.renderer2.setAttribute(this.el.nativeElement, 'src', '');
  }

  ngOnInit(): void {

    if (this.originalUrl.startsWith('data:') || this.originalUrl.indexOf('//privatecdn.') !== -1 || this.originalUrl.indexOf('/_vti_bin/') !== -1) {
      if (this.originalUrl.indexOf('//privatecdn.') !== -1) {
        this.originalUrl = this.originalUrl.replace('privatecdn.sharepointonline.com/', '');
      }
      this.renderer2.setAttribute(this.el.nativeElement, 'src', this.originalUrl);
      this.cdRef.detectChanges();

    } else if (this.originalUrl.endsWith('sitepagethumbnail.png')) {

      this.renderer2.setAttribute(this.el.nativeElement, 'src', Constants.TRANSPARENT_IMAGE);
      this.cdRef.detectChanges();

    } else if (this.originalUrl.indexOf('getpreview.ashx') !== -1) {

      this.subscription = this.imageService
        .getSharePointImageThumbnailFromPreviewHandlerUrl(this.originalUrl)
        .subscribe(result => {
          if (result) {
            this.renderer2.setAttribute(this.el.nativeElement, 'src', result);
          } else {
            this.renderer2.setAttribute(this.el.nativeElement, 'src', Constants.TRANSPARENT_IMAGE);
          }
          this.cdRef.detectChanges();
        },
          (err) => {
            this.renderer2.setAttribute(this.el.nativeElement, 'src', Constants.TRANSPARENT_IMAGE);
          });

    } else if (this.originalUrl.indexOf('/_api/v2.1/') !== -1 || this.originalUrl.indexOf('/_api/v2.0/') !== -1 || this.originalUrl.indexOf('//cdn.') !== -1) {

      this.subscription = this.imageService
        .getThumbnailFromApiUrl(this.originalUrl)
        .subscribe(result => {
          if (result) {
            this.renderer2.setAttribute(this.el.nativeElement, 'src', result);
          } else {
            this.renderer2.setAttribute(this.el.nativeElement, 'src', Constants.TRANSPARENT_IMAGE);
          }
          this.cdRef.detectChanges();
        },
          (err) => {
            this.renderer2.setAttribute(this.el.nativeElement, 'src', Constants.TRANSPARENT_IMAGE);
          });

    } else {
      this.subscription = this.imageService
        .getSharePointImageThumbnailFromOriginalUrlWithStandardDimensions(this.originalUrl)
        .subscribe(result => {
          if (result) {
            this.renderer2.setAttribute(this.el.nativeElement, 'src', result);
          } else {
            this.renderer2.setAttribute(this.el.nativeElement, 'src', this.originalUrl);
          }
          this.cdRef.detectChanges();
        },
          (err) => {
            this.renderer2.setAttribute(this.el.nativeElement, 'src', this.originalUrl);
          });
    }
  }

  ngOnDestroy(): void {
    this.subscription && this.subscription.unsubscribe();
  }
}
@NgModule({
  declarations: [ImgSrcProxyDirective],
  exports: [ImgSrcProxyDirective],
})
export class ImgSrcProxyModule { }
